import { Outlet, Link } from 'react-router-dom';
import { MarketplaceNav } from './MarketplaceNav';
import { PersonaSwitcher } from './PersonaSwitcher';
import { usePersona } from '../../../contexts/PersonaContext';

export function MarketplaceLayout() {
  const { isImpersonating } = usePersona();

  return (
    <div className={`min-h-screen flex flex-col bg-spi-cream ${isImpersonating ? 'pt-8' : ''}`}>
      <MarketplaceNav />
      <main className="flex-1">
        <Outlet />
      </main>
      <footer className="bg-spi-green-dark text-white py-6">
        <div className="container mx-auto px-4 flex flex-col sm:flex-row items-center justify-between gap-2 text-sm opacity-80">
          <a href="https://baycrewtech.com" target="_blank" rel="noopener noreferrer" className="hover:opacity-100 hover:underline">&copy; {new Date().getFullYear()} Bay Crew Tech, LLC. All rights reserved.</a>
          <div className="flex items-center gap-4">
            <Link to="/marketplace/terms" className="hover:opacity-100 hover:underline">Terms of Service</Link>
            <Link to="/marketplace/privacy" className="hover:opacity-100 hover:underline">Privacy Policy</Link>
          </div>
        </div>
      </footer>
      <PersonaSwitcher />
    </div>
  );
}
